import React from 'react';
import styled from 'styled-components';

import StartDatePresetCategory from './components/StartDatePresetCategory';
import PickerContainer from '../PickerContainer';
import PickerHeading from '../PickerHeading';

import { PRESET_CATEGORY_NAME_TO_ICON } from './constants';
import type { IStartDatePresetPicker } from './types';

export const StartDatePresetPicker = (props: IStartDatePresetPicker): JSX.Element => {
  const {
    selectedStartDatePreset,
    calendarStartDatePreset,
    selectStartDatePreset,
    isMobile,
    startDatePresets,
    customStartDatePreset,
  } = props;

  const presetCategories =
    calendarStartDatePreset || customStartDatePreset
      ? startDatePresets.map((category) => {
          if (category.name === 'nearest_dates') {
            const [firstLine, ...otherLines] = category.options;

            return {
              ...category,
              options: [
                [
                  ...(calendarStartDatePreset ? [calendarStartDatePreset] : []),
                  ...(customStartDatePreset ? [customStartDatePreset] : []),
                  ...firstLine,
                ],
                ...otherLines,
              ],
            };
          }

          return category;
        })
      : startDatePresets;

  return (
    <PickerContainer $isMobile={isMobile} $order={isMobile ? 2 : 1}>
      <PickerHeading>Укажите когда вылет</PickerHeading>
      <StyledCategoriesContainer>
        {presetCategories.map((presetCategoryProps) => (
          <StartDatePresetCategory
            key={presetCategoryProps.name}
            presets={presetCategoryProps.options}
            icon={PRESET_CATEGORY_NAME_TO_ICON[presetCategoryProps.name]}
            selectedPreset={selectedStartDatePreset || calendarStartDatePreset?.name}
            selectPreset={selectStartDatePreset}
            isMobile={isMobile}
          />
        ))}
      </StyledCategoriesContainer>
    </PickerContainer>
  );
};

const StyledCategoriesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-content: flex-start;

  margin-top: 8px;

  width: 100%;
`;
